import React from 'react'

const Imgvideo = () => {
    return (
        <div>

        </div>
    )
}

export default Imgvideo

{/* <iframe width="740" height="460" src="https://www.youtube.com/embed/rcIWb6fxcms" title="How To Use Mind Maps" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}